import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full mt-4 table-fixed"
}
const _hoisted_2 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_3 = { class: "px-2 py-2 w-1/5" }
const _hoisted_4 = { class: "capitalize" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_18815_11689)\"><rect width=\"18\" height=\"18\" fill=\"white\" fill-opacity=\"0.01\"></rect><path transform=\"rotate(180, 9, 9)\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.22873 1.85285C5.28098 1.80046 5.34306 1.7589 5.41139 1.73055C5.47973 1.70219 5.55299 1.68759 5.62698 1.68759C5.70097 1.68759 5.77423 1.70219 5.84257 1.73055C5.91091 1.7589 5.97298 1.80046 6.02523 1.85285L12.7752 8.60285C12.8276 8.6551 12.8692 8.71717 12.8975 8.78551C12.9259 8.85385 12.9405 8.92711 12.9405 9.0011C12.9405 9.07508 12.9259 9.14835 12.8975 9.21668C12.8692 9.28502 12.8276 9.34709 12.7752 9.39935L6.02523 16.1493C5.91961 16.255 5.77635 16.3143 5.62698 16.3143C5.47761 16.3143 5.33435 16.255 5.22873 16.1493C5.12311 16.0437 5.06377 15.9005 5.06377 15.7511C5.06377 15.6017 5.12311 15.4585 5.22873 15.3528L11.5816 9.0011L5.22873 2.64935C5.17635 2.5971 5.13479 2.53502 5.10643 2.46668C5.07807 2.39835 5.06348 2.32509 5.06348 2.2511C5.06348 2.17711 5.07807 2.10385 5.10643 2.03551C5.13479 1.96717 5.17635 1.9051 5.22873 1.85285V1.85285Z\" fill=\"#6C757D\"></path></g><defs><clipPath id=\"clip0_18815_11689\"><rect width=\"18\" height=\"18\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex flex-wrap justify-center items-center" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_18815_11689)\"><rect width=\"18\" height=\"18\" fill=\"white\" fill-opacity=\"0.01\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.22873 1.85285C5.28098 1.80046 5.34306 1.7589 5.41139 1.73055C5.47973 1.70219 5.55299 1.68759 5.62698 1.68759C5.70097 1.68759 5.77423 1.70219 5.84257 1.73055C5.91091 1.7589 5.97298 1.80046 6.02523 1.85285L12.7752 8.60285C12.8276 8.6551 12.8692 8.71717 12.8975 8.78551C12.9259 8.85385 12.9405 8.92711 12.9405 9.0011C12.9405 9.07508 12.9259 9.14835 12.8975 9.21668C12.8692 9.28502 12.8276 9.34709 12.7752 9.39935L6.02523 16.1493C5.91961 16.255 5.77635 16.3143 5.62698 16.3143C5.47761 16.3143 5.33435 16.255 5.22873 16.1493C5.12311 16.0437 5.06377 15.9005 5.06377 15.7511C5.06377 15.6017 5.12311 15.4585 5.22873 15.3528L11.5816 9.0011L5.22873 2.64935C5.17635 2.5971 5.13479 2.53502 5.10643 2.46668C5.07807 2.39835 5.06348 2.32509 5.06348 2.2511C5.06348 2.17711 5.07807 2.10385 5.10643 2.03551C5.13479 1.96717 5.17635 1.9051 5.22873 1.85285V1.85285Z\" fill=\"#6C757D\"></path></g><defs><clipPath id=\"clip0_18815_11689\"><rect width=\"18\" height=\"18\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "px-2 py-6 md:py-3" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-wrap justify-center items-center"
}
const _hoisted_13 = { class: "flex flex-wrap justify-center items-center" }
const _hoisted_14 = {
  key: 1,
  class: "font-bold"
}

import { ref, computed, watch } from "vue";
import { formatDate } from "@/utils/dates";


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackTable',
  props: {
  surveyData: {
    type: Array,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const memberFeedbackSurveyQuestions = ref([]);

const memberFeedbackSurveyResults = ref([]);

const memberFeedbackTablePage = ref(0);

const memberFeedbackTablePaginated = computed(() => {
  const page = memberFeedbackTablePage.value;
  return memberFeedbackSurveyResults.value.slice(page * 5, (page + 1) * 5);
});

const memberFeedbackTablePageLast = computed(() => {
  return Math.ceil(memberFeedbackSurveyResults.value.length / 5) - 1;
});

const emojiHappy = `😊`;
const emojiSad = `😞`;
const emojiNeutral = `😐`;
const emojiVeryHappy = `😄`;
const emojiVerySad = `😢`;



function useEmoji(text: String) {
    if (props.type == "student" || props.type == "session") {
        const textUpper = text?.toUpperCase();
        const emotionArray = ['GOOD', 'YES', 'POSITIVE', 'BAD', 'NO', 'NEGATIVE', 'OKAY', 'SOMETIMES', 'NEUTRAL', 'VERY GOOD', 'VERY POSITIVE', 'VERY BAD', 'VERY NEGATIVE'];
        return emotionArray.some(emotion => textUpper?.includes(emotion));
    } else {
        return false;
    }
}

function getEmoji(text: String) {
    const textUpper = text?.toUpperCase();
    if (textUpper == 'GOOD' || textUpper == 'YES' || textUpper == 'POSITIVE') return emojiHappy;
    else if (textUpper == 'BAD' || textUpper == 'NO' || textUpper == 'NEGATIVE') return emojiSad;
    else if (textUpper == 'OKAY' || textUpper == 'SOMETIMES' || textUpper == 'NEUTRAL') return emojiNeutral;
    else if (textUpper == 'VERY GOOD' || textUpper == 'VERY POSITIVE') return emojiVeryHappy;
    else if (textUpper == 'VERY BAD' || textUpper == 'VERY NEGATIVE') return emojiVerySad;
    else return text?.replaceAll(",", ", ").toLowerCase();
}

function cleanResponseText(text: String) {
    const textLower = text?.replaceAll(",", ", ").toLowerCase();
    return textLower.charAt(0).toUpperCase() + textLower.slice(1);
}

function getMemberSurveyResultsFeedback() {
  const sessionFeedback = props.surveyData.find((group: { group_name: string; }) => group.group_name === "brick-club-session-feedback");
  if (sessionFeedback && sessionFeedback?.surveys?.[0]) {
    memberFeedbackSurveyQuestions.value = sessionFeedback.surveys[0].questions;
    memberFeedbackSurveyResults.value = sessionFeedback.surveys[0].results;
  }
}

function getMemberSurveyResultsEvaluation() {
  const sessionFeedback = props.surveyData.find((group: { group_name: string; }) => group.group_name === "brick-club-evaluation");
  if (sessionFeedback && sessionFeedback?.surveys?.[0]) {
    sessionFeedback?.surveys?.find((survey) => {
      if (survey?.results?.[0]?.survey_response?.user_type === props.type) {
        memberFeedbackSurveyQuestions.value = survey.questions;
        memberFeedbackSurveyResults.value = survey.results;
      }
    });
  }
}

if (props.type === "session") getMemberSurveyResultsFeedback();
else getMemberSurveyResultsEvaluation();

// Watch for changes to surveyData and call getMemberSurveyResultsEvaluation if it changes
watch(
  () => props.surveyData,
  (newVal, oldVal) => {
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        if (props.type === "session") {
            getMemberSurveyResultsFeedback();
        } else {
            console.log('eval dat has changed');
            getMemberSurveyResultsEvaluation();
        }
    }
  },
  { deep: true }
);


return (_ctx: any,_cache: any) => {
  return (memberFeedbackSurveyResults.value.length)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("thead", _hoisted_2, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["justify-between", { flex : memberFeedbackTablePage.value }])
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("question")), 1),
                (memberFeedbackTablePage.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (memberFeedbackTablePage.value--))
                    }, _hoisted_6))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberFeedbackTablePaginated), (survey, index) => {
              return (_openBlock(), _createElementBlock("th", {
                key: index,
                class: "px-2 py-2"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["justify-between", { flex : (index == _unref(memberFeedbackTablePaginated).length - 1) && (memberFeedbackTablePage.value !== _unref(memberFeedbackTablePageLast))}])
                }, [
                  ((index == _unref(memberFeedbackTablePaginated).length - 1) && (memberFeedbackTablePage.value !== _unref(memberFeedbackTablePageLast)))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatDate)(new Date(survey?.survey_response?.responded_at))), 1),
                  ((index == _unref(memberFeedbackTablePaginated).length - 1) && (memberFeedbackTablePage.value !== _unref(memberFeedbackTablePageLast)))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (memberFeedbackTablePage.value++))
                      }, _hoisted_10))
                    : _createCommentVNode("", true)
                ], 2)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memberFeedbackSurveyQuestions.value, (question, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "border-b border-gray-400",
              key: index
            }, [
              _createElementVNode("td", _hoisted_11, _toDisplayString(question.question_text), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberFeedbackTablePaginated), (response, index2) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: "px-2 py-6 md:py-3",
                  key: index2
                }, [
                  (useEmoji(response.answers.find(i => i.question_id === question.question_id)?.answer_text))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(getEmoji(response.answers.find(i => i.question_id === question.question_id)?.answer_text)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(cleanResponseText(response.answers.find(i => i.question_id === question.question_id)?.answer_text)), 1)
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t("no-feedback")), 1))
}
}

})